<template>
  <sfs-base-table
    :data-provider="$complianceDocumentVerificationsAPI.getComplianceDocumentVerifications"
    :data-id="complianceDocumentCoverageId"
    provider-key="verifications"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
  >
    <template #cell(user_id)="data">
      <b-link :to="{ name: 'user', params: { id: data.item.user.id } }">
        {{ data.item.user.name }}
      </b-link>
    </template>
    <template #cell(audited_at)="data">
      {{ data.item.audited_at | dateTimeFormat }}
    </template>
  </sfs-base-table>
</template>

<script>
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_DEFAULT_COLUMNS } from '@/constants/complianceDocumentVerifications';

export default {
  name: 'ComplianceDocumentVerificationsTable',
  mixins: [tablePropsMixin],
  props: {
    complianceDocumentCoverageId: {
      type: Number,
      required: true,
    },
    columns: {
      type: Array,
      default: () => COMPLIANCE_DOCUMENT_VERIFICATIONS_TABLE_DEFAULT_COLUMNS,
    },
  },
};
</script>
